import React from "react";
import { Dashboard } from "./Dashboard/Dashboard";
import { DashboardCharts } from "./Dashboard/DashboardCharts";

export default function VendorDashboard() {
  return <div style={{ maxHeight: "calc(80vh - 10px)" }}><Dashboard />
    <DashboardCharts /></div>;
}
